/** the `source` the auto-applied coupon event carries so the funnel can tell this apply from a tap */
export const HARDWARE_FIRST_IN_APP_PROMO_SOURCE = 'hardware_first_in_app';

export interface HardwareFirstInAppPromoDecision {
  activePromoCode: string | undefined;
  cartItemCount: number;
  cartCouponCode: string | undefined;
  cartReferralCode: string | undefined;
  redeemedGiftCardCode: string | undefined;
  /** a referral link's cookie, which `useAutoApplyReferral` turns into `cartReferralCode` a beat later */
  hasReferralCookie: boolean;
  /** a gift card cookie, which `useApplyGiftCardFromCookie` redeems onto the cart a beat later */
  hasGiftCardCookie: boolean;
  inPartnerContext: boolean;
  alreadyAttempted: boolean;
}

/**
 * Whether the live promotion's code should be applied to an in-app hardware-first cart. The code is
 * applied once per cart contents, only to a cart with no code of any kind on it, and never over a
 * partner offer or a referral or gift card cookie the shopper brought with them. A coupon cookie is
 * deliberately not a veto: the banner replays it on page load, so a code that still works is on the
 * cart before anything can be added, and a code that has since expired (last week's promo) must not
 * keep this week's from applying.
 */
export function shouldAutoApplyHardwareFirstInAppPromo(decision: HardwareFirstInAppPromoDecision): boolean {
  return (
    !!decision.activePromoCode &&
    decision.cartItemCount > 0 &&
    !decision.cartCouponCode &&
    !decision.cartReferralCode &&
    !decision.redeemedGiftCardCode &&
    !decision.hasReferralCookie &&
    !decision.hasGiftCardCookie &&
    !decision.inPartnerContext &&
    !decision.alreadyAttempted
  );
}
